<template>
  <v-container v-bind:class="{ 'pa-0': !isMobilePc }">
    <general-dialog v-model="modal" :title="popupTitle" :buttons="buttons">
      <v-card flat>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col cols="12">
                <p>마지막 비밀번호 변경후 180일이 지났습니다.</p>
                <p>비밀번호 변경을 권장드립니다. 변경하시겠습니까?</p>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </general-dialog>
    <!--<v-dialog v-model="component_show">
      <v-card class="top_title"> &nbsp; 공지사항</v-card>
        <v-card>
          <span>
            &nbsp; <input type="checkbox" :id="'chkToday'"> &nbsp;5일동안 열지 않음 &nbsp;
            <v-btn varient="plain" size="small" @click="closeLayer"> 닫기</v-btn>
          </span>
        </v-card>
      <div class="main_content">
        <img src="@/assets/image/popup.jpg" width="100%">
      </div>
    </v-dialog>-->
    <v-card
      class="main_card2 px-4"
      v-bind:class="{ 'v-full-width': !isMobilePc }"
      width="35%"
      style="top:5%; right:1%;"
    >
      <v-row>
        <v-col class="pa-2" cols="6">
          <gauge-card
            title="발전량"
            :max="Math.round((siteTotal.totalCapacity * 1.1) / 1000)"
            :value="
              isNaN(siteTotal.pvpcsPac)
                ? 0
                : Math.round(siteTotal.pvpcsPac / 1000)
            "
            color="#90F072"
            :flag="flag"
            :isDark="isDark"
            unit="MW"
          ></gauge-card>
        </v-col>
        <v-col class="pa-2" cols="6">
          <text-card
            title="당일 발전량"
            :value="Math.round(siteTotal.pvpcsDailyP / 1000)"
            color="#00FFFA"
            unit="MWH"
          ></text-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pa-2" cols="6">
          <state-table
            :visible="true"
            title="사이트 현황"
            stateName="총사이트"
            :state-value="siteTotal.totalCount"
            :run-val="siteTotal.runCount + siteTotal.pauseCount"
            :err-val="siteTotal.faultCount"
            :str-val="siteTotal.errorCount"
          ></state-table>
        </v-col>
        <v-col class="pa-2" cols="6">
          <state-table
            :visible="true"
            title="인버터 현황"
            stateName="총인버터"
            :state-value="inverterTotal.totalCount"
            :run-val="inverterTotal.runCount + inverterTotal.pauseCount"
            :err-val="inverterTotal.faultCount"
            :str-val="inverterTotal.errorCount"
          ></state-table>
        </v-col>
      </v-row>
      <v-row class="justify-end" no-gutters>
        <v-radio-group
          row
          hide-details
          class="pa-0 ma-0"
          v-on:change="changeList"
          v-model="premiumOrAll"
        >
          <v-radio label="전체" value="all"></v-radio>
          <v-radio label="프리미엄" value="premium"></v-radio>
        </v-radio-group>
      </v-row>
      <v-row>
        <v-card class="full-width card--group pa-1 mt-2 mb-4">
          <v-col class="pa-0 scrolling" cols="12">
            <v-card class="ma-1">
              <v-row
                class="text-center ma-0 px-2"
                style="font-size: .7rem;"
                v-for="(item, idx) in sidoData"
                v-bind:key="'location_' + idx"
              >
                <v-layout style="border-bottom: 1px solid gray">
                  <v-col
                    cols="3"
                    class="pa-1 d-flex justify-center align-center font-size-medium"
                    >{{ item.sidoName }}</v-col
                  >
                  <v-col
                    cols="4"
                    class="pa-1 d-flex justify-start align-center font-size-medium"
                    v-on:click="showSido(item.sidoCode, 'S')"
                  >
                    가동
                    <span
                      class="pl-1 bold font-size-large"
                      style="color: var(--v-txtblue-base)"
                      >{{ item.runCount }}</span
                    >
                  </v-col>
                  <v-col
                    class="pa-1 d-flex justify-start align-center font-size-medium"
                    v-on:click="showSido(item.sidoCode, 'F')"
                  >
                    고장
                    <span class="pl-1 font-size-large" style="color: red;">{{
                      item.faultCount
                    }}</span>
                  </v-col>
                  <v-col
                    class="pa-1 d-flex justify-start align-center font-size-medium"
                    v-on:click="showSido(item.sidoCode, 'E')"
                  >
                    통신
                    <span
                      class="pl-1 font-size-large"
                      style="color: #b99c00;"
                      >{{ isNaN(item.errorCount) ? 0 : item.errorCount }}</span
                    >
                  </v-col>
                </v-layout>
              </v-row>
            </v-card>
          </v-col>
        </v-card>
      </v-row>
    </v-card>
    <v-dialog
      v-if="popup"
      v-model="popup"
      persistent
      max-width="450px"
      style="overflow-x: hidden;"
    >
      <as-dialog
        :detail="dialogTitle"
        @closeDetailPop="popup = false"
        :list="regionInfos"
        :dialogStatus="dialogStatus"
      ></as-dialog>
    </v-dialog>
  </v-container>
</template>

<script>
import { dateRenew } from '@/api/common/login'
// 스크립트를 정의하는 부분
// 개발자 작업 영역
// import StockBlock from '@/components/monitoring/StockBlock.vue'
import StateTable from '@/components/mobile/StateTable.vue'
import GaugeCard from '@/components/mobile/m_GaugeCard'
import AsDialog from '@/components/mobile/AsDialog'
// import DetailStatusPopup from '@/components/monitoring/DetailStatusPopup'
import TextCard from '@/components/mobile/TextCard'
import { isMobile } from '@/utils/check.js'
import { getMonitoringTotal, getSearchSite } from '@/api/monitoring/monitoring'
import GeneralDialog from '@/components/dialogSet/GeneralDialog'
import localStore from '@/utils/localStore'
import { confirmIfExit } from '@/api/greenCommon/confirmIfExit'
import _ from 'lodash'

export default {
  name: 'CenterAS',
  components: {
    // StockBlock,
    StateTable,
    GaugeCard,
    // DetailStatusPopup,
    TextCard,
    AsDialog,
    GeneralDialog
  },
  mixins: [],
  data() {
    return {
      row_num: 0,
      component_key: 1,
      layer_type: 'SummaryPopup',
      component_show: false,
      modal: false,
      popupTitle: '비밀번호 변경',
      buttons: [
        {
          title: '변경',
          color: 'primary',
          class: 'white--text',
          handler: () => {
            this.closePopup({ ok: true })
          }
        },
        {
          title: '다음에 변경하기',
          text: true,
          handler: () => {
            this.closePopup({ ok: false })
          }
        }
      ],
      premiumOrAll: 'all',
      dialogTitle: '지역별 정보',
      image: {
        run: require('@/assets/image/monitoring/mak-gr-28.png'), // 가동
        fault: require('@/assets/image/monitoring/mark-rd-28.png'), // 고장
        error: require('@/assets/image/monitoring/mark-yl-28.png') // 통신이상
      },
      resultDialog: [],
      dialogStatus: 'N',
      visibility: 'A',
      count: 0,
      isCharge: false,
      usergroup: '',
      siteTotal: {
        dailyTime: 0,
        errorCount: 0,
        expectPrice: 0,
        faultCount: 0,
        pauseCount: 0,
        pvpcsDailyP: 0,
        pvpcsPac: 0,
        runCount: 0,
        totalCapacity: 0,
        totalCount: 0
      },
      inverterTotal: {
        dailyTime: 0,
        errorCount: 0,
        expectPrice: 0,
        faultCount: 0,
        pauseCount: 0,
        pvpcsDailyP: 0,
        pvpcsPac: 0,
        runCount: 0,
        totalCapacity: 0,
        totalCount: 0
      },
      faultList: [],
      errorList: [],
      runList: [],
      base_date: {
        y: '',
        m: '',
        d: ''
      },
      sites: [],
      sidoData: [],
      allSidoData: [],
      sidoCodeList: [
        '11',
        '26',
        '27',
        '28',
        '29',
        '30',
        '31',
        '36',
        '41',
        '42',
        '43',
        '44',
        '45',
        '46',
        '47',
        '48',
        '50'
      ],
      popup: false,
      sidoFlag: [],
      paramTitle: '',
      paramStatus: '',
      paramList: '',
      searchParam: '',
      flag: 0,
      isMobilePc: true,
      siteList: {},
      regionInfos: {},
      isDark: false
    }
  },
  created() {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.
    // this.getMonitorData()
  },
  watch: {
    '$vuetify.theme.isDark'() {
      this.isDark = this.$vuetify.theme.isDark
    }
  },
  mounted() {
    this.isDark = this.$vuetify.theme.isDark
    this.$store.dispatch('SetLoadingDialog', true)
    this.$nextTick(() => {
      this.getMonitorData()
    })
    this.intervalHandler = setInterval(() => {
      if (this.premiumOrAll === 'all') {
        this.getMonitorData()
      } else {
        this.getMonitorDataPremium()
      }
    }, 60000 * 2)
    if (isMobile()) {
      this.isMobilePc = false
      // confirmIfExit()
    }
    window.addEventListener('resize', this.setHeightOfImage)
    // DOM에 해당 .vue가 들어가게 되면 실행 되는 곳
    // onload 상태와 동일하다. DOM 이후에 조작할 경우 이곳에서 수행
    this.initData()
    this.popup2()
    var pwChangeYN = localStore.get('pw_change')
    if (pwChangeYN === 'Y') {
      this.modal = true
    } else {
    }
  },
  computed: {
    imageFlag(flag) {
      return flag
    },
    // 값이 자주 변경됨에 따라, 관련되어 데이터 혹은 view가 바뀌어야 할 경우 사용
    // method를 바로 연결하면 tic 단위로 계속 실행되기 때문에, 값이 변경할 때만 수행되고,
    // cache로 남는 computed를 활용하는 것이 성능에 좋음
    total() {
      let pvpcsPac = 0
      let pvpcsDailyP = 0
      let time = 0
      let capacity = 0
      let price = 0
      this.sites.forEach(x => {
        pvpcsPac += x.PVPCS_Pac
        pvpcsDailyP += x.PVPCS_Daily_P
        price += x.expectPrice
        capacity += x.totalCapacity
      })
      time = (pvpcsDailyP / capacity).toFixed(2)
      pvpcsPac = pvpcsPac.toFixed(2)
      pvpcsDailyP = pvpcsDailyP.toFixed(2)
      price = price.toFixed(0)
      return {
        pvpcsPac,
        pvpcsDailyP,
        price,
        time,
        capacity
      }
    }
  },
  methods: {
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
    changeList() {
      this.$store.dispatch('SetLoadingDialog', true)
      if (this.premiumOrAll === 'all') {
        this.getMonitorData()
      } else {
        this.getMonitorDataPremium()
      }
    },
    getTableData(param) {
      getSearchSite(param).then(res => {
        this.paramStatus = 'search'
        this.paramList = res
      })
    },
    openSearchPopup() {
      getSearchSite(this.searchParam).then(res => {
        this.paramStatus = 'search'
        this.paramList = res
        this.popup = true
      })
    },
    openPopup(title, list, status) {
      this.paramTitle = title
      this.paramList = list
      this.paramStatus = status
      this.popup = true
    },
    getMonitorData() {
      getMonitoringTotal().then(res => {
        if (res.siteTotal) {
          this.siteTotal = {}
          this.siteTotal = res.siteTotal
        }
        if (res.inverterTotal) {
          this.inverterTotal = {}
          this.inverterTotal = res.inverterTotal
        }
        this.sidoFlag = []
        Object.keys(res.sido).forEach(key => {
          this.sidoFlag.push(key)
        })
        this.sidoData = []
        // this.sidoData = res.sido
        let arr = []
        for (let key in res.sido) {
          arr.push(res.sido[key])
        }
        arr = _.sortBy(arr, 'runCount').reverse()
        this.sidoData = arr
        this.flag++
      })
    },
    getMonitorDataPremium() {
      getMonitoringTotal('', '', 'P').then(res => {
        if (res.siteTotal) {
          this.siteTotal = {}
          this.siteTotal = res.siteTotal
        }
        if (res.inverterTotal) {
          this.inverterTotal = {}
          this.inverterTotal = res.inverterTotal
        }
        this.sidoFlag = []
        Object.keys(res.sido).forEach(key => {
          this.sidoFlag.push(key)
        })
        this.sidoData = []
        // this.sidoData = res.sido
        let arr = []
        for (let key in res.sido) {
          arr.push(res.sido[key])
        }
        arr = _.sortBy(arr, 'runCount').reverse()
        this.sidoData = arr
        this.flag++
      })
      getMonitoringTotal('', '', 'P').then(rs => {
        this.allSidoData = rs
      })
    },
    showStock(stock) {
      this.visibility = stock
    },
    getVisibility(show) {
      if (this.sidoFlag === show) {
        return true
      } else if (this.sidoFlag === 'A') {
        return true
      } else {
        return false
      }
    },
    setHeightOfImage() {
      // fitHeightOfElement(this.$refs.img, 450)
    },
    init_counting(response) {
      this.siteInfo.total_service_cnt = response.siteList.length

      this.siteInfo.total_normal_service = response.siteList.filter(
        d => d.STATUS === '0'
      ).length

      this.siteInfo.total_abnormal_service = response.siteList.filter(
        d => d.STATUS !== '0'
      ).length

      for (let index = 0; index < this.siteInfo.regions.length; index++) {
        this.siteInfo.regions[index].run_cnt = response.siteList.filter(
          d =>
            d.STATUS === '0' &&
            d.AREA === this.siteInfo.regions[index].region_area
        ).length

        this.siteInfo.regions[index].stop_cnt = response.siteList.filter(
          d =>
            d.STATUS !== '0' &&
            d.AREA === this.siteInfo.regions[index].region_area
        ).length
      }
    },
    initData() {
      let params = {}

      const grpAuth = this.$store.state.user.grp_auth || ''
      if (
        grpAuth !== 'usergroup001' &&
        grpAuth !== 'usergroup002' &&
        grpAuth !== 'usergroup004'
      ) {
        this.user_id = localStore.get('userId')
        this.usergroup = grpAuth

        if (this.user_id !== '') {
          params = {
            user_id: this.user_id,
            isCharge: this.isCharge,
            userGroup: this.usergroup
          }
        }
      } else {
        params.user_id = ''
        params.isCharge = this.isCharge
      }

      // getSiteList(params).then(response => {
      //   if (response) {
      //     this.siteList = response.siteList
      //   }
      //   // this.init_counting(response)
      // })
    },
    showSido(i, t) {
      // this.dialogTitle = this.sidoData[i].sidoName
      const d = _.filter(this.sidoData, { sidoCode: i.toString() })
      this.dialogTitle = d[0].sidoName
      if (t === 'S') {
        this.regionInfos = d[0].runList
        this.dialogStatus = 'N'
      } else if (t === 'E') {
        this.regionInfos = d[0].errorList
        this.dialogStatus = 'Y'
      } else {
        this.regionInfos = d[0].faultList
        this.dialogStatus = 'E'
      }
      // this.regionInfos = this.sidoData[i].runList
      if (this.regionInfos.length > 50) {
        // this.regionInfos = this.regionInfos.splice(0, 50)
      }
      this.popup = true
    },
    popup2() {
      // 첫 화면에서 팝업을 띄운다
      this.layer_type = 'SummaryPopup'

      let found = false
      let start, end
      let i = 0

      while (i <= document.cookie.length) {
        start = i
        end = start + 'popup'.length
        if (document.cookie.substring(start, end) === 'popup') {
          found = true
          break
        }
        i++
      }

      if (found === true) {
        console.log('cookie found')
        this.component_show = false
      } else {
        console.log('cookie not found')
        this.component_show = true
      }

      // this.component_show = true
    },
    closeLayer() {
      if (document.getElementById('chkToday').checked) {
        let todayDate = new Date()
        todayDate.setDate(todayDate.getDate() + 5)
        document.cookie =
          'popup' +
          '=' +
          escape('no') +
          '; path=/; expires=' +
          todayDate.toGMTString() +
          ';'
        this.component_show = false
      } else {
        this.component_show = false
      }

      // this.component_show = true
    },
    closePopup(result) {
      if (result.ok) {
        this.modal = false
        this.$router.replace('/mypage')
      } else {
        this.modal = false
        dateRenew(localStore.get('userId'))
        localStore.set('pw_change', '')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main_card2 {
  table {
    font-size: 12px;
    color: black;
    width: 100%;
    border: solid 1px rgb(210, 210, 210);
    border-collapse: collapse;
    tr {
      td {
        text-align: center;
        border: solid 1px rgb(210, 210, 210);
        padding: 0px 0px 0px 0px;
        white-space: pre-line;
      }
      th {
        text-align: center;
        padding-top: 2px;
        padding-bottom: 2px;
        background-color: rgb(225, 230, 236);
      }
    }
  }
}
</style>
<style scoped>
/* .v-responsive__content {
    width: 100% !important;
  } */
.v-full-width {
  width: 100% !important;
  right: 0 !important;
  padding-bottom: 20px;
}
.scrolling {
  overflow: auto;
  height: 300px;
}
.full-width {
  width: 100%;
}
.font-size-medium {
  font-size: 12px;
}
.font-size-large {
  font-size: large;
}
</style>
